// Libraries
import {
  Directive,
  ContentChild
} from '@angular/core';

// Components
import { ItemBodyComponent } from './../../components/item/item-body.component';

/**
 * `ItemDirective` implements toggle functionality for item element.
 *
 * Example:
 * ```
 * <div class="item light bordered" wpItem>
 *  <div class="item-title">
 *    <div class="caption">
 *      <span class="caption-subject bold uppercase font-dark">item title</span>
 *    </div>
 *    <div class="actions">
 *      <button type="button" class="btn btn-secondary" wpItemToggle>
 *        <i class="fa fa-compress" [class.fa-expand]="itemBody.isCollapsed"
 *          [class.fa-compress]="!itemBody.isCollapsed" aria-hidden="true"></i>
 *      </button>
 *    </div>
 *  </div>
 *  <wp-item-body class="item-body" #itemBody>
 *    <h1>Body</h1>
 *     <button type="button" class="btn btn-secondary" wpItemToggle eventName="close">
 *        <i class="fa fa-times" aria-hidden="true"></i>
 *     </button>
 *  </wp-item-body>
 * </div>
 * ```
 */
@Directive({
  selector: '[wpItem]'
})
export class ItemDirective {
  // Public properties
  /**
   * Mantain item body.
   */
  @ContentChild(ItemBodyComponent)
  itemBody: ItemBodyComponent;
}
